import {useSelector} from 'react-redux';

import type {RootState} from '../..';

import type {ColorSetting} from '../../../entities';
import {useIsFeatureInTier} from '../../../utils/component';
import {useActions} from '../../../utils/globalStore';
import {actions as UiActions} from '../duck';

const productImageShapeSelector = (state: RootState) =>
  state.ui.storeInformation &&
  state.ui.storeInformation.imageSetting &&
  state.ui.storeInformation.imageSetting.productImageShapeType;

export function useProductImageShape() {
  const productImageShapeConfig = useSelector(productImageShapeSelector);
  const hasImageShapeFeature = useIsFeatureInTier('IMAGE_CONFIGURATION');

  const productImageShape = hasImageShapeFeature
    ? productImageShapeConfig
    : 'SQUARE';

  return productImageShape || 'SQUARE';
}

const storeColorSettingsSelector = (state: RootState) =>
  state.ui.storeInformation && state.ui.storeInformation.colorSetting;

export function useStoreColorSettings(): ColorSetting | null {
  const colorSettings = useSelector(storeColorSettingsSelector);
  return colorSettings || null;
}

const storeInformationSelector = (state: RootState) =>
  state.ui.storeInformation;
export function useStoreUiInformation() {
  const storeInformation = useSelector(storeInformationSelector);
  return storeInformation;
}

const tier22ModalOpenSelector = (state: RootState) => state.ui.tier22ModalOpen;

export function useTier22Modal() {
  const isOpen = useSelector(tier22ModalOpenSelector);
  const {openTier22Modal: open, closeTier22Modal: close} = useActions({
    openTier22Modal: UiActions.openTier22Modal,
    closeTier22Modal: UiActions.closeTier22Modal,
  });

  return {isOpen, open, close};
}
